:host {
  --background-color: var(--stzh-editor-background-color, #{$colorGrey10});

  @media print {
    display: none;
  }
}

.stzh-editor {
  @include spaceCurve('padding-top', 'regular');
  @include spaceCurve('padding-bottom', 'large');
  background-color: var(--background-color);

  &__wrapper {
    @include container;
  }

  &__heading {
    @include font('heavy');
    @include fontCurve('p2');

    &:not(:empty) {
      margin-bottom: space('medium');
    }
  }

  &__link-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;

    @include mq($from: medium) {
      gap: space('medium');
    }
  }
}
